export default "__VITE_ASSET__B3BA4iR0__"